import { Button, TextInput } from 'ui';

const PasswordTabContent = () => {
  return (
    <>
      <TextInput name="old_password" label="OLD PASSWORD" />
      <TextInput name="new_password" label="NEW PASSWORD" />
      <TextInput name="repeated_new__password" label="REPEAT NEW PASSWORD" />
      <Button>Change password</Button>
    </>
  );
};

export default PasswordTabContent;
